import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { selectHasSelectedCompanyFilterAccess } from 'containers/App/selectors'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../../PartnerOptions/constants'

import { fetchDataError, fetchDataSuccess } from './actions'
import { DATA_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS, DATA_REQUEST_ASYNC.INITIATE),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    }),
    mergeMap(() =>
      !selectHasSelectedCompanyFilterAccess(state$.value)
        ? of(DATA_REQUEST_ASYNC.cancel())
        : api.dashboard.getRecentCampaigns(state$.value.partnerOptions.selectedCompany?.value).pipe(
            map((response) => fetchDataSuccess(response)),
            catchError((error) => of(epicsErrorHandler(fetchDataError, error))),
            takeUntil(action$.pipe(ofType(DATA_REQUEST_ASYNC.CANCEL)))
          )
    )
  )

export default combineEpics(fetchDataEpic)
